import React, { FC } from 'react'

const PrivacyPolicy: FC = () => {
  return (
    <object
      style={{ minWidth: '100vw', minHeight: '100vh' }}
      aria-label="pdf"
      type="application/pdf"
      data="/files/privacy-policy.pdf"
    />
  )
}

export default PrivacyPolicy
